




















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Utils } from '@/pitprojekt/utils';
import moment from 'moment'


@Component({})
export default class TopBrowsersTableCard extends Vue {
  @Prop(String) title!: string
  @Prop(Object) data!: object
  @Prop(Object) dataAggregated!: object
  @Prop(Boolean) isLoading!: boolean;
  @Prop(Boolean) isPageLoading!: boolean;
  @Prop(Number) total!: number;
  pagination: object = {};
  headers: object = [
            {
                text: 'Sys.',
                sortable: false,
            },
            {
                text: 'Przeg.',
                sortable: false,
            },
            {
                text: 'Wersja',
                sortable: false,
                value: 'browser'
            },
            {
                text: 'Ilość',
                sortable: false,
                value: 'count'
            }
        ];

  @Watch('pagination')
  onPagination() {
    this.$emit('loadData', this.pagination);
  }

  formattedBrowser(browserName: string|boolean, browserVersion: string|boolean): string {
    let formattedBrowser: string = '';

    if ( browserName != false) formattedBrowser += browserName;
    if ( browserVersion != false) formattedBrowser += (formattedBrowser=='') ? browserVersion : ' '+browserVersion;
    if (formattedBrowser == '')  formattedBrowser = 'nieznana';
    return formattedBrowser;
  }

  tooltipTypeIcon(type: string, robotName: string|boolean): string {
    let formattedTooltip: string = type;
    if ( robotName != false) formattedTooltip += ' '+robotName;
    return formattedTooltip;
  }

  getDeviceIconName(device: string) {
    return Utils.getDeviceIconName(device);
  }

  getWebBrowserIconUrl(browserName: string) {
    return Utils.getWebBrowserIconUrl(browserName);
  }

  getOperatingSystemIconUrl(platform: string) {
    return Utils.getOperatingSystemIconUrl(platform);
  }

  tooltipSystemIcon(platform: string|boolean, platformVersion: string|boolean): string {
    let formattedTooltip: string = '';

    if ( platform != false) formattedTooltip += platform;
    if ( platformVersion != false) formattedTooltip += (formattedTooltip=='') ? platformVersion : ' '+platformVersion;
    if (formattedTooltip == '')  formattedTooltip = 'nieznana platforma';
    return formattedTooltip;
  }

  created() {
    this.requireIcons();
  }

  requireIcons() {
    var req = require.context("@/assets/img/icons/", false, /.*\.svg$/);
    req.keys().forEach(function(key){
      req(key);
    });
  }


}
